(() => {
  let pending = false;
  function placeChat() {
    pending = false;
    const host = document.querySelector('shopify-chat');
    const runtime = host?.shadowRoot?.querySelector('shopify-agent-runtime');
    const button = runtime?.shadowRoot?.querySelector('[part~="activator"]') || host?.shadowRoot?.querySelector('[part~="activator"]');
    if (!button || button.getAttribute('aria-expanded') === 'true') return;
    const current = Number(host.dataset.babymeChatOffset || -80);
    const box = button.getBoundingClientRect();
    if (!box.width || !box.height) return;
    const targets = Array.from(document.querySelectorAll('.quick-add__submit, .product-form__submit, .shopify-payment-button, button[name="checkout"], input[name="checkout"]'))
      .map(el => el.getBoundingClientRect()).filter(r => r.width && r.height && r.bottom > 0 && r.top < innerHeight);
    const offsets = [-80, -160, -240, -320, -400, 0];
    const next = offsets.find(offset => {
      const top = box.top - current + offset;
      const bottom = top + box.height;
      return top >= 16 && bottom <= innerHeight - 16 && !targets.some(r => box.left < r.right + 12 && box.right > r.left - 12 && top < r.bottom + 12 && bottom > r.top - 12);
    });
    host.toggleAttribute('data-babyme-chat-blocked', next === undefined);
    button.inert = next === undefined;
    if (next !== undefined) {
      host.dataset.babymeChatOffset = String(next);
      host.style.setProperty('--babyme-chat-offset', next + 'px');
    }
  }
  function schedule() {
    if (!pending) { pending = true; requestAnimationFrame(placeChat); }
  }
  addEventListener('scroll', schedule, {passive:true, capture:true});
  addEventListener('resize', schedule, {passive:true});
  addEventListener('load', schedule);
  document.addEventListener('shopify:section:load', schedule);
  const main = document.querySelector('main');
  if (main) new MutationObserver(schedule).observe(main, {childList:true, subtree:true});
  [0, 250, 1000, 3000, 6000].forEach(delay => setTimeout(schedule, delay));
})();